var crypto = require('crypto');
import setting from '@/setting'

export function encodeAES(data) {
	var cipher = crypto.createCipheriv('aes-128-cbc', setting.AESPass, setting.AESPass);
	var crypted = cipher.update(data, 'utf8', 'binary');
	crypted += cipher.final('binary');
	crypted = new Buffer(crypted, 'binary').toString('base64');
	return crypted;
}
